import { useState, useEffect } from 'react';
import Layout from './components/Layout';
import ItineraryRail from './components/ItineraryRail';
import Map from './components/Map';
import Login from './components/Login';
import { useAppState } from './state/store';
import { useAuthStore } from './state/authStore';
import { Stop } from './types';
import './styles/app.css';

function App() {
  const { setSelectedStopId } = useAppState();
  const { isAuthenticated, initialize } = useAuthStore();
  const [mapInstance, setMapInstance] = useState<google.maps.Map | null>(null);

  // Initialize auth state on app load
  useEffect(() => {
    initialize();
  }, [initialize]);

  const handleStopClick = (stop: Stop) => {
    setSelectedStopId(stop.id);
    if (mapInstance) {
      mapInstance.setCenter({ lat: stop.lat, lng: stop.lng });
      mapInstance.setZoom(14);
    }
  };

  // Show login if not authenticated
  if (!isAuthenticated) {
    return <Login />;
  }

  // Show main app if authenticated
  return (
    <Layout
      leftRail={<ItineraryRail onStopClick={handleStopClick} />}
      map={<Map className="map-container" onMapReady={setMapInstance} />}
    />
  );
}

export default App;

